import { LOGIN_STATUS } from '../Types';

export default function login(state = [], action){
   switch(action.type){
      case LOGIN_STATUS:
         return action.payload;
      default:
         return state;
   }
};